export abstract class CustomStorage {
  abstract get sizeStorage(): number;
  abstract getItem({ key }: { key: string }): string;
  abstract removeItem({ key }: { key: string }): void;
  abstract clearStorage(): void;
}

export abstract class Storage {}
